<template>
  <el-dialog
    width="940px"
    top="30vh"
    :visible.sync="dialogCurrency"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    custom-class="code-dialog"
  >
    <div sort="title" class="code-title">{{ $t('pay_discount_title', { level: levelName }) }}</div>
    <div class="head-line"></div>
    <div class="code-select-box">
      <DiscountCell
        :cellData="item"
        :modelId="selectId"
        :mIndex="index"
        v-on:click.native="onSelect(index)"
        v-for="(item, index) in discountData"
        :key="index"
      ></DiscountCell>
    </div>
    <div class="flex" style="margin: 32px 0 30px 0">
      <mui-button
        class="code-button"
        @click="onClick"
        type="yellow"
        size="large"
        :loading="loading"
        :loadingText="$t('loading')"
        >{{ $t('pay') }}</mui-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { getCodesDiscount } from '@/serves/api/useCode'
import DiscountCell from './DiscountCell.vue'
import { getToken } from '@/utils/cache'

export default {
  name: 'DiscountDialog',
  components: { DiscountCell },
  watch: {
    '$store.state.level.levelId': {
      handler(val) {
        if (val) {
          // 监听level_id本地数据变化 刷新页面
          this.onRefreshDiscountData(val)
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      dialogCurrency: false,
      loading: false,
      selectId: 0,
      discountData: [],
      tipText: '',
      levelName: '',
    }
  },
  mounted() {},
  methods: {
    onRefreshDiscountData(levelId) {
      this.loading = true
      console.log('获取当前模拟试卷的价格和折扣', levelId)
      if (!levelId) {
        return
      }
      getCodesDiscount({ level_id: levelId })
        .then((res) => {
          console.log('当前折扣信息：', res.data)
          this.discountData = res?.data?.products
          this.levelName = res.data.level_name
          this.loading = false
        })
        .catch((err) => {
          console.log('获取折扣接口报错：', err)
        })
    },
    openDialog() {
      if (this.loading) return
      if (!getToken()) {
        this.$store.dispatch('user/handleLogout', { reLogin: true })
        this.loading = true
        return
      }
      this.dialogCurrency = true
    },
    closeDialog() {
      this.loading = false
      this.dialogCurrency = false
    },
    // 点击购买 如果是已购买状态 直接关闭
    onClick() {
      if (this.loading) return
      this.loading = true
      // 创建订单
      let data = this.discountData[this.selectId]
      console.log('点击购买 onClickBuy', data)
      this.$emit('onClickBuy', data)
    },
    onSelect(id) {
      console.log(id)
      this.selectId = id
    },
  },
}
</script>

<style lang="scss" scoped>
.code-dialog {
  .code-title {
    color: #2c2f46;
    padding-top: 20px;
    padding-left: 24px;
    font-family: Proxima Nova;
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 20px;
  }
  .head-line {
    width: 100%;
    height: 1px;
    background: #efeff1;
  }
  .code-select-box {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding: 20px 5px;
    // border: 1px solid #000000;
  }
  .code-body {
    padding: 0px 25px;
    letter-spacing: 0em;
    text-align: center;
    font-family: Inter;
    color: #000000;

    .code-desc {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
    }
    .code-list {
      font-weight: 700;
      margin: 20px 0;
      line-height: 29px;
      font-size: 24px;
    }
  }
  .code-button {
    width: auto;
    min-width: 254px;
    height: 40px;
    border-radius: 4px;
    margin: 0 auto;
    margin-bottom: 27px;

    font-family: Proxima Nova;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0em;
    text-align: center;
  }
}
</style>
